/**
 * In View Observer
 * Adds 'in-view' class to elements when they come into viewport
 * Usage: Add class 'observe-in-view' to any element you want to animate
 */

function inViewObserver() {
    // Select all elements with the observe class
    const observeElements = document.querySelectorAll('.observe-in-view');

    if (!observeElements.length) return;

    // Create intersection observer
    const observerOptions = {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0.7 // trigger when 50% of element is visible    
    };

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                // Add in-view class when element enters viewport
                entry.target.classList.add('in-view');

                // Stop observing after animation (one-time only)
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe all elements
    observeElements.forEach(function (element) {
        observer.observe(element);
    });
}

export default inViewObserver;
